import {
  IconGenderBigender,
  IconGenderFemale,
  IconGenderMale,
} from '@tabler/icons-react';
import type { GenderOption } from '../../constants/gender';
import { normalizeGender } from '../../constants/gender';

const GENDER_ICONS = {
  Male: IconGenderMale,
  Female: IconGenderFemale,
  Other: IconGenderBigender,
} as const;

interface GenderOptionLabelProps {
  gender: string;
  size?: number;
}

const GenderOptionLabel = ({ gender, size = 18 }: GenderOptionLabelProps) => {
  const normalized = normalizeGender(gender) as GenderOption | string;
  const Icon =
    normalized in GENDER_ICONS
      ? GENDER_ICONS[normalized as GenderOption]
      : IconGenderBigender;

  return (
    <span className="inline-flex items-center gap-2">
      <Icon size={size} stroke={1.75} aria-hidden className="shrink-0" />
      <span>{gender || 'Select gender'}</span>
    </span>
  );
};

export default GenderOptionLabel;
